// Vendors
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
// Components
import {
  IconComponent,
  LoaderComponent,
  ParagraphComponent,
  TitleComponent,
} from '@openbank/ziniaweb-ui-components';
// Constants
import {
  KYC_BIZUM_AMOUNT_PROPS,
  KYC_BIZUM_LOADER_PROPS,
  KYC_BIZUM_LOGO_PROPS,
  KYC_BIZUM_TITLE_PROPS,
} from './constants/kyc-bizum.constants';
// Hooks
import { useKycBizumHook } from './hooks/kyc-bizum.hook';
// Styles
import {
  KycBizumLoaderStyled,
  KycBizumViewStyled,
  KycBizumTopLoaderStyled,
} from './kyc-bizum.view.styled';
import { TextBoldComponentStyled } from 'styles/app.styled';
// Translations
import { KYC_BIZUM_DESCRIPTION } from './translations/kyc-bizum.translations';
// Utilities
import { convertSecondsToMinutesAndSeconds } from './utils/kyc-bizum.utils';

const KycBizumView = (): React.JSX.Element => {
  const { timer } = useKycBizumHook();

  return (
    <KycBizumViewStyled>
      <KycBizumLoaderStyled>
        <IconComponent {...KYC_BIZUM_LOGO_PROPS} />
        <KycBizumTopLoaderStyled>
          <LoaderComponent {...KYC_BIZUM_LOADER_PROPS} />
          <TitleComponent
            {...KYC_BIZUM_TITLE_PROPS}
            title={convertSecondsToMinutesAndSeconds(timer)}
          />
        </KycBizumTopLoaderStyled>
      </KycBizumLoaderStyled>
      <ParagraphComponent>
        <FormattedMessage
          id={KYC_BIZUM_DESCRIPTION}
          values={{
            amount: (
              <TextBoldComponentStyled>
                <FormattedNumber {...KYC_BIZUM_AMOUNT_PROPS} />
              </TextBoldComponentStyled>
            ),
          }}
        />
      </ParagraphComponent>
    </KycBizumViewStyled>
  );
};

export { KycBizumView };
